/*
 * Copyright (c) 2014-2023 Comparatio
 */

const tableCols = [
	{
		field : 'ZO1_ID',
		header : '',
		visible : true,
		filter : false,
		sort : false,
		tooltip : '',
		export : { visible : false, checked : false },
		width : 0
	},
	{
        field: 'COMPANY_NAME',
        header: 'Company',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Company',
        export: {visible: true, checked: true},
        width: 50
    },
    {
        field: 'ZO1_BRANCH',
        header: 'Branch',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Branch',
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'CUSTOMER_NAME',
        header: 'Customer',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Customer',
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'ZO1_ITEM',
        header: 'Item',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Item',
        export: {visible: true, checked: true},
        width: 60
    },
	{
		field : 'ZO1_RESTRICT_INVENTORY_FIXED',
		header : 'Restrict from Inventory Feed',
		visible : true,
		filter : true,
		sort : true,
		tooltip : 'Restrict from Inventory Feed',
		export : { visible : true, checked : true },
		width : 20
	},
    {
        field: 'ZO1_DISPLAY_INVENTORY_FIXED',
        header: 'Inventory Fixed Percent',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Inventory Fixed Percent',
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'ZO1_DISPLAY_FIXED_QUANTITY',
        header: 'Inventory Fixed Quantity',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Inventory Fixed Quantity',
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'ZO1_START_DATE',
        header: 'Start Date',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Start Date',
        export: {visible: true, checked: true},
        width: 35
    },
    {
        field: 'ZO1_END_DATE',
        header: 'End Date',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'End Date',
        export: {visible: true, checked: true},
        width: 35
    },
    {
        field: 'ACTIONS',
        header: 'Actions',
        visible: true,
        filter: false,
        sort: false,
        tooltip: 'Actions',
        export: {visible: false, checked: false},
        width: 30
    }
];
export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/zero-out-inventory/zero-out-inventory.cols.ts